import { PiiSearchPage } from '@repo/ccc-case-app-lib/src/pages/PiiSearchPage.tsx'
import { ErrorPage } from '@repo/internal-tools-app-lib/src/lib/ErrorPage.tsx'
import {
  DEFAULT_PERMISSION_ERROR_MESSAGE,
  PERMISSION_RESOURCE_KEYS,
} from '@repo/internal-tools-permission/src/constants/permission.ts'
import { CanView } from '@repo/internal-tools-permission/src/lib/CanView.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/pii')({
  component: () => (
    <CanView
      resource={PERMISSION_RESOURCE_KEYS.PII_SEARCH}
      fallback={
        <ErrorPage
          code="403"
          description={DEFAULT_PERMISSION_ERROR_MESSAGE}
          className="w-full"
        />
      }
    >
      <PiiSearchPage />
    </CanView>
  ),
})
